import {
    padStart,
} from 'lodash'    
    
const returnToday = () => {
    const tmpDate = new Date()
    let tmpMonth = padStart(tmpDate.getMonth() + 1, 2, '0')
    let tmpDay = padStart(tmpDate.getDate(), 2, '0')
    let tmpYear = tmpDate.getFullYear()
    return `${tmpYear}-${tmpMonth}-${tmpDay}`
}

export default returnToday